module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "mode": "out-in",
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "animated"
  }, [_c('mainHeader'), _vm._v(" "), (_vm.$route.name !== 'index') ? _c('div', {
    staticClass: "container"
  }, [_c('sideNav', {
    staticClass: "nav"
  }), _vm._v(" "), _c('router-view', {
    staticClass: "view"
  })], 1) : _c('router-view', {
    staticClass: "page"
  }), _vm._v(" "), (_vm.$route.name !== 'index') ? _c('mainFooter') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6e03bdb8"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./client/components/AppMain.vue
// module id = 276
// module chunks = 3